import { Button } from '@shared/components/ui/button';
import { DateRangePicker } from '@shared/components/ui/DateRangePicker';
import { useCallback } from 'react';
import type { DateRange } from 'react-day-picker';
import { useTranslation } from 'react-i18next';

export interface ReadyToPrepareFiltersValue {
  dateFrom: string;
  dateTo: string;
}

interface FiltersBarProps {
  value: ReadyToPrepareFiltersValue;
  onApply: (next: ReadyToPrepareFiltersValue) => void;
  getDefaultRange: () => ReadyToPrepareFiltersValue;
}

export const FiltersBar = ({ value, onApply, getDefaultRange }: FiltersBarProps) => {
  const { t } = useTranslation('readyToPrepareByHourModule');

  const handleDateRangeUpdate = useCallback(
    ({ range: r }: { range: DateRange }) => {
      if (!r.from || !r.to) return;
      const yf = r.from.getFullYear();
      const mf = String(r.from.getMonth() + 1).padStart(2, '0');
      const df = String(r.from.getDate()).padStart(2, '0');
      const yt = r.to.getFullYear();
      const mt = String(r.to.getMonth() + 1).padStart(2, '0');
      const dt = String(r.to.getDate()).padStart(2, '0');
      onApply({
        dateFrom: `${yf}-${mf}-${df}`,
        dateTo: `${yt}-${mt}-${dt}`,
      });
    },
    [onApply],
  );

  const handleReset = useCallback(() => {
    onApply(getDefaultRange());
  }, [onApply, getDefaultRange]);

  return (
    <div className="flex flex-col sm:flex-row sm:items-end gap-3 flex-wrap">
      <div className="space-y-1.5 min-w-[280px] flex-1">
        <span className="text-sm font-medium text-foreground">{t('filters.period', 'Periodo')}</span>
        <DateRangePicker
          initialDateFrom={value.dateFrom}
          initialDateTo={value.dateTo}
          onUpdate={handleDateRangeUpdate}
          align="start"
          showPresets
          triggerClassName="bg-card-bg border-card-border w-full transition-colors"
          placeholder={t('filters.period_placeholder', 'Seleccionar rango de fechas')}
          dataTestId="ready-to-prepare-date-range"
        />
      </div>
      <Button type="button" variant="outline" className="shrink-0" onClick={handleReset}>
        {t('filters.reset', 'Restablecer')}
      </Button>
    </div>
  );
};
